import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

class ActionButton extends PureComponent {
  render() {
    const {
      text,
      inverted,
      borderBold,
      disabled,
      onClick,
      small,
      large,
      activeColor,
      rounded,
      bold,
      fullWidth,
      className,
      hide,
      ...props
    } = this.props;
    return (
      <button
        className={cx(
          'ActionButton',
          {
            inverted,
            disabled,
            borderBold,
            small,
            large,
            rounded,
            bold,
            fullWidth,
            hide,
          },
          className,
        )}
        onClick={!disabled ? onClick : null}
        {...props}
      >
        {text}
      </button>
    );
  }
}

ActionButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  inverted: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  rounded: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  bold: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default ActionButton;
